import { DivLabel, DivValue, DivWrap } from './style';
import { getFormattedDate } from '../util';

type CaptureDateProps = {
  label: string;
  date?: string | Date | null;
  icon?: React.ReactNode;
};

export default function ImageryDate({ label, date, icon }: CaptureDateProps) {
	if (!date) return null;

	return (
		<DivWrap>
			{icon && <span>{icon}</span>}
			<DivLabel>
				<label>{label}</label>
				<DivValue>{getFormattedDate(new Date(date))}</DivValue>
			</DivLabel>
		
		</DivWrap>
	);
}
